import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/generateImage.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 22 24",
	...n,
	children: [
		/* @__PURE__ */ e("g", {
			clipPath: "url(#clip0_27462_33615)",
			children: /* @__PURE__ */ e("path", {
				fill: "#fff",
				d: "M16.29 9.57a.62.62 0 0 1-.582-.398l-.993-2.582a.4.4 0 0 0-.229-.229l-2.582-.993a.624.624 0 0 1 0-1.164l2.582-.993a.4.4 0 0 0 .229-.229L15.708.4a.623.623 0 0 1 1.164 0l.992 2.582a.4.4 0 0 0 .23.229l2.566.987a.635.635 0 0 1 .415.6.62.62 0 0 1-.399.57l-2.582.992a.4.4 0 0 0-.229.23l-.993 2.582a.62.62 0 0 1-.582.399"
			})
		}),
		/* @__PURE__ */ e("g", {
			clipPath: "url(#clip1_27462_33615)",
			children: /* @__PURE__ */ e("path", {
				fill: "#fff",
				d: "M8.796 3.257a4 4 0 0 0-.32 1.285l-.013.299.012.299a3.96 3.96 0 0 0 2.526 3.391L11 8.532l1.364.525.525 1.364a3.95 3.95 0 0 0 3.677 2.534h.016l.018.001v-.001a3.95 3.95 0 0 0 3.4-1.961v8.9a3.334 3.334 0 0 1-3.334 3.334H3.333A3.334 3.334 0 0 1 0 19.895V6.59a3.333 3.333 0 0 1 3.333-3.333zm-.765 6.789a.63.63 0 0 0-.54.306L1.93 19.28a.325.325 0 0 0 .12.443c.049.03.106.045.163.046h15.574a.34.34 0 0 0 .283-.167.33.33 0 0 0 0-.322l-3.682-5.712a.644.644 0 0 0-1.093 0l-1.107 1.775a.35.35 0 0 1-.284.154.35.35 0 0 1-.27-.154l-3.063-4.992a.63.63 0 0 0-.54-.306m6.023-2.018-.005.011.006-.018z"
			})
		}),
		/* @__PURE__ */ t("defs", { children: [/* @__PURE__ */ e("clipPath", {
			id: "clip0_27462_33615",
			children: /* @__PURE__ */ e("rect", {
				width: 9.57,
				height: 9.57,
				fill: "#fff",
				transform: "translate(11.504)"
			})
		}), /* @__PURE__ */ e("clipPath", {
			id: "clip1_27462_33615",
			children: /* @__PURE__ */ e("rect", {
				width: 20,
				height: 19.971,
				fill: "#fff",
				transform: "translate(0 3.257)"
			})
		})] })
	]
});
//#endregion
export { n as default };
